import { PRICING_MODELS } from '@/modules/Contract/constants'
import { Contract, ServiceConfigOption } from '@/modules/Contract/types'
import { useEffect, useMemo } from 'react'
import { Control, Path } from 'react-hook-form'

interface useServicePriceTotalProps {
    setValue: (name: Path<Contract>, value: any) => void
    index: number
    control: Control<Contract>
    service_configoptions: ServiceConfigOption[]
    servicePriceModel?: string
}

const useServicePriceTotal = ({
    setValue,
    index,
    service_configoptions,
    servicePriceModel = 'package',
}: useServicePriceTotalProps) => {
    const total = useMemo(() => {
        const price_config =
            servicePriceModel !== PRICING_MODELS.Bundle
                ? 0
                : service_configoptions?.reduce((tot, i) => {
                      tot +=
                          (i?.commitment_value || 0) *
                          (i?.commitment_price_per_unit || 0)
                      return tot
                  }, 0) || 0

        return price_config
    }, [service_configoptions])

    useEffect(() => {
        if (servicePriceModel === PRICING_MODELS.Bundle) {
            setValue(
                `order.products.[${index}].service_price_register` as Path<Contract>,
                total || 0
            )
            return
        }
    }, [total, servicePriceModel])
}

export default useServicePriceTotal
